import React from 'react';
import {
	func,
	object
} from 'prop-types';
import { tlSecondsToMinute } from '../../../logics/utility';
import style from './style';

const RecipeCard = ({ recipe, onClickTag, onClickCard, ...props }) => {
	let timeLimitStr = '';
	const thumbsCount = (recipe.thumbFrom && recipe.thumbFrom.length) || 0;
	const likeCount = (recipe.likeFrom && recipe.likeFrom.length) || 0;
	if (recipe.timeLimit) {
		const { min, sec } = tlSecondsToMinute(recipe.timeLimit);
		timeLimitStr = <React.Fragment><style.TimerIcon /><style.Timer>
			{`${min}:${sec}`}
		</style.Timer></React.Fragment>;
	}
	return (
		<style.Wrapper {...props} onClick={onClickCard}>
			<style.Layout>
				<style.UserBlock>
					<style.AvatarIcon src={recipe.imageUrl || 'https://via.placeholder.com/100x100/ffffff/616161.png?text=No+Image'} />
					<style.UserName>
						{recipe.userName}
					</style.UserName>
				</style.UserBlock>

				<style.Divider />

				<style.RecipeBlock>
					<style.Title>
						{recipe.name}
					</style.Title>
					<style.Discription>
						{recipe.discription}
					</style.Discription>
				</style.RecipeBlock>
				<style.TagsWrapper>
					{recipe.tags && recipe.tags.map(tag => <style.ReadOnlyTag
						text={tag}
						key={tag}
						onClick={onClickTag}
					/>)}
				</style.TagsWrapper>
			</style.Layout>
			<style.SupportingInfoWrapper>

				<style.Icons>
					{timeLimitStr}
					<style.ThumbsUpIcon /> {thumbsCount}
					<style.StarIcon /> {likeCount}
				</style.Icons>
			</style.SupportingInfoWrapper>

		</style.Wrapper>
	);
}

RecipeCard.propTypes = {
	recipe: object.isRequired,
	onClickTag: func.isRequired,
	onClickCard: func.isRequired
};

export default RecipeCard;